module.exports = __webpack_public_path__ + "static/media/11-2.c77f114d.mp3";